import { partFields, partSummaries } from "./partFields";
import {
  manufacturingFields,
  manufacturingSummaries
} from "./manufacturingFields";
import { t } from "i18next";

export const chartFields = (kind) => {
  switch (kind) {
    case "part":
      return partFields;
    case "manufacturingStep":
      return manufacturingFields;
    default:
      return [];
  }
};

export const chartSummaries = (kind) => {
  switch (kind) {
    case "part":
      return partSummaries;
    case "manufacturingStep":
      return manufacturingSummaries;
    default:
      return [];
  }
};

// Prepare data for cost breakdown chart
// converts values to ranges (sum from previous values to current value)
// with overall summaries
export const prepareBreakdownChartData = (values, kind) => {
  const result = [];
  const fields = chartFields(kind);
  const summaries = chartSummaries(kind);
  let sum = 0;

  for (let i = 0; i < fields.length; i++) {
    if (summaries.includes(fields[i])) {
      // Only manufacturing_costs_part starts from material_costs_part [kind = part]
      if (kind === "part" && fields[i] === "manufacturing_costs_part") {
        result[i] = [values.material_costs_part, sum];
      } else {
        // All other summaries start from 0
        result[i] = [0, values[fields[i]]];
      }
    } else {
      const high = sum + Number(values[fields[i]]);
      result[i] = [sum, high];
      sum = high;
    }
  }
  return result;
};
export const smallCostBreakDownChartOptions = (title) => {
  return {
    responsive: true,
    layout: {},
    scales: {
      x: {
        ticks: {
          display: false
        }
      },
      y: {
        ticks: {
          display: false
        },
        title: {
          display: false
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: title
      },
      customCanvasBackgroundColor: {
        color: "white"
      },
      colors: {
        enabled: true
      },
      datalabels: {
        display: false
      },
      legend: {
        display: false
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }

            if (context.parsed.y !== null) {
              const value =
                context.parsed._custom.barEnd - context.parsed._custom.barStart;
              label += new Intl.NumberFormat("de-DE", {}).format(value) + " €";
            }

            return label;
          }
        }
      }
    }
  };
};

// Look & feel options for cost breakdown chart
export const costBreakdownChartOptions = (title, isMultiple) => {
  return {
    responsive: true,
    layout: {
      padding: 48
    },
    scales: {
      y: {
        ticks: {
          callback: function (value, index, values) {
            return new Intl.NumberFormat("de-DE", {
              style: "decimal"
            }).format(value);
          }
        },
        title: {
          display: true,
          text: t("entities.part.fields.cost")
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: title
      },
      customCanvasBackgroundColor: {
        color: "white"
      },
      colors: {
        enabled: true
      },
      legend: {
        display: isMultiple
      },
      datalabels: {
        display: true,
        anchor: "end",
        align: "end",
        rotation: 270,
        formatter: function (value, context) {
          return !(value[1] - value[0])
            ? null
            : new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 2
              }).format(value[1] - value[0]);
        }
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }

            if (context.parsed.y !== null) {
              const value =
                context.parsed._custom.barEnd - context.parsed._custom.barStart;
              label += new Intl.NumberFormat("de-DE", {}).format(value) + " €";
            }

            return label;
          }
        }
      }
    }
  };
};

// Make chart background white (default is transparent)
// PNG doesn't look great with transparent background
export const customCanvasBackgroundColor = {
  id: "customCanvasBackgroundColor",
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = options.color || "#99ffff";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
};

// Download chart as PNG
export const downloadChartPng = (canvas) => {
  const dataURL = canvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.download = "breakdown-chart.png";
  link.href = dataURL;
  link.click();
};
